import axios from "axios"

import { POSTS_LIMIT } from "@/constants/postsFeed.js"

export const posts = ({ key, cursor }) =>
  axios.get(`/api/v2/users/${key}/recent_posts`, {
    params: {
      cursor,
      limit: POSTS_LIMIT
    }
  })

export const getProfileBadges = ({ userId }) => axios.get(`/api/v2/users/${userId}/badges`)
